export default "__VITE_ASSET__D7xZQ8Dz__"